/// <amd-module name="Feed/Legacy/Components/LoadingContainer" />
import * as React from "react";

import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { css } from "VSSUI/Util";

export interface ILoadingContainerProps {
    isLoading: boolean;
    cssClass?: string;
}

export class LoadingContainer extends React.PureComponent<ILoadingContainerProps> {
    public render(): JSX.Element {
        const isLoading = this.props.isLoading;
        const className = css("flex flex-column flex-grow", isLoading ? "loading" : "", this.props.cssClass);

        return (
            <div className={className}>
                {isLoading ? (
                    <Spinner size={SpinnerSize.large} className="loading-container-spinner" />
                ) : (
                    this.props.children
                )}
            </div>
        );
    }
}
